import Module from "../module";
import * as en from "./translations/en.json";
import baseRoute from "./routes/index";

export default new Module(baseRoute, { en, nl: {} }, [
	"can_manage_booking_experts",
]);
